import { cleanObjFromEmptyVal } from "./helpfulFunctions";

export const isExternalURL = (url: string) => url.match(/http[s]?\/\//i);
export const isExternalModifiedURL = (url: string) =>
  url?.match(/http[s]?:\/\//i);
export const getQueryParams = (query: string | object) => {
  const cleanQuery = checkIfObj(query) ? cleanObjFromEmptyVal(query) : query;
  const params = new URLSearchParams(cleanQuery);
  return params;
};

export const getCorrectIconUrl = ({ genImgUrl, cdnUrl }, image) =>
  isExternalModifiedURL(genImgUrl(image))
    ? genImgUrl(image)
    : cdnUrl + genImgUrl(image);

export const getHubDownloadUrl = (link: string) => {
  const url = new URL(link, window.location.origin);

  if (url.origin !== window.location.origin) {
    throw new Error("External URL is not allowed");
  }

  if (url.protocol !== window.location.protocol) {
    throw new Error("Invalid protocol");
  }

  const pathname = url.pathname.replace(/^\/+/, "");
  const mediaPath = pathname.startsWith("media/")
    ? pathname
    : `media/${pathname}`;

  return new URL(mediaPath, window.location.origin).toString();
};

const checkIfObj = (el) =>
  typeof el === "object" && !Array.isArray(el) && el !== null;

export const checkIsFilterValueExist = (value) => {
    return Array.isArray(value)
      ? value.length > 0 && value[0] !== "all"
      : !!value && value !== "all";
  };

export const buildFilter = (filter) => {
  const assembledFilter = {};

  for (const [key, value] of Object.entries(filter) as any) {
    if (checkIsFilterValueExist(value)) {
      assembledFilter[key] = value;
    }
  }

  return assembledFilter;
};
